<template>
  <v-container>
    <v-card>
      <v-card-title>
        パスワードの変更
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row dense>
          <v-col
            cols="9"
            offset="3">
            <v-row
              dense>
              <v-col cols="6">
                <v-text-field
                  v-model="form.current_password"
                  outlined
                  dense
                  type="password"
                  :error-messages="validationError.current_password"
                  label="現在のパスワード" />
                <v-text-field
                  v-model="form.password"
                  outlined
                  dense
                  type="password"
                  :error-messages="validationError.password"
                  label="新しいパスワード" />
                <v-text-field
                  v-model="form.password_confirmation"
                  outlined
                  dense
                  type="password"
                  :error-messages="validationError.password_confirmation"
                  label="新しいパスワード(確認)" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <global-footer>
      <template #left>
        <v-btn
          @click.prevent="onCancelClicked">
          キャンセル
        </v-btn>
      </template>
      <template #right>
        <v-btn
          color="primary"
          @click.prevent="onSaveClicked">
          保存
        </v-btn>
      </template>
    </global-footer>
  </v-container>
</template>

<script>

export default {
  name: 'PasswordChange',
  data() {
    return {
      form: {
        current_password: '',
        password: '',
        password_confirmation: '',
      },
      validationError: {},
    }
  },
  mounted() {
  },
  methods: {
    onCancelClicked() {
      this.$router.push({ name: 'index' })
    },
    async onSaveClicked() {
      try {
        await window.axios.put('/api/password', this.form)
        this.$store.commit(
          'setSystemMessage',
          { message: '会員情報を変更しました。', color: 'success' },
        )
        this.$router.push({ name: 'index' })
      } catch ({ response }) {
        if (response.status === 422) {
          this.validationError = response.data.errors
        }
      }
    },
  },
}
</script>
